import { bannerData } from "../../../../globals/banner";
import Banner from "../../../sections/common/banner";

import SectionPortfolio1 from "../../../sections/home/index/section-portfolio1";

function Portfolio2Page() {
    return (
        <>
            <Banner _data={bannerData.portfolio2} />
            <SectionPortfolio1 />
            
        </>
    )
}

export default Portfolio2Page;